import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { heroXMark } from '@ng-icons/heroicons/outline';
import {
  Component,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
  inject,
  input,
  viewChild,
} from '@angular/core';

@Component({
  selector: 'ui-popover',
  imports: [NgIconComponent],
  templateUrl: './popover.component.html',
  viewProviders: [
    provideIcons({
      heroXMark,
    }),
  ],
})
export class PopoverComponent implements OnInit, OnDestroy {
  private overlay = inject(Overlay);
  private viewContainerRef = inject(ViewContainerRef);

  readonly contentTemplate = viewChild.required(TemplateRef);
  readonly triggerElementRef = input.required<HTMLElement>();
  readonly openAbove = input(false);
  private isOpen = false;

  private overlayRef!: OverlayRef;

  ngOnInit() {
    const triggerElementWidth = this.triggerElementRef().offsetWidth;
    const overlayConfig = new OverlayConfig({
      hasBackdrop: true,
      backdropClass: 'bg-transparent',
      minWidth: triggerElementWidth,
      positionStrategy: this.overlay
        .position()
        .flexibleConnectedTo(this.triggerElementRef())
        .withPositions([
          {
            originX: 'start',
            originY: this.openAbove() ? 'top' : 'bottom', // Adjusted dynamically
            overlayX: 'start',
            overlayY: this.openAbove() ? 'bottom' : 'top', // Adjusted dynamically
            offsetY: this.openAbove() ? -6 : 6,
          },
        ]),
      scrollStrategy: this.overlay.scrollStrategies.reposition(),
    });

    this.overlayRef = this.overlay.create(overlayConfig);
    this.overlayRef.backdropClick().subscribe(() => this.closePopover());
  }

  openPopover() {
    if (!this.isOpen) {
      const portal = new TemplatePortal(
        this.contentTemplate(),
        this.viewContainerRef
      );
      this.overlayRef.attach(portal);
      this.isOpen = true;
    }
  }

  closePopover() {
    if (this.overlayRef && this.overlayRef.hasAttached()) {
      this.overlayRef.detach();
      this.isOpen = false;
    }
  }
  isPopoverOpen(): boolean {
    return this.isOpen;
  }
  togglePopover() {
    if (!this.isPopoverOpen()) {
      this.openPopover();
    } else {
      this.closePopover();
    }
  }

  ngOnDestroy() {
    if (this.overlayRef) {
      this.overlayRef.dispose();
      this.isOpen = false;
    }
  }
}
